import axios from "axios";
import { invalidateOverviewCache } from "./lib/overviewCache";
import { installReportCache } from "./lib/reportCache";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
const pending = new Set();
let sessionVersion = 0;
let authTransitioning = false;

export const beginAuthTransition = () => {
  invalidateOverviewCache();
  authTransitioning = true;
  sessionVersion += 1;
  pending.forEach((controller) => controller.abort());
  pending.clear();
};

export const completeAuthTransition = () => {
  authTransitioning = false;
};

api.interceptors.request.use((c) => {
  c.imcInvalidatesOverview = !["get", "head", "options"].includes(String(c.method || "get").toLowerCase());
  if (c.imcInvalidatesOverview) invalidateOverviewCache();
  const t = localStorage.getItem("imc_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const controller = new AbortController();
  const callerSignal = c.signal;
  if (callerSignal) {
    const abort = () => controller.abort();
    if (callerSignal.aborted) controller.abort();
    else callerSignal.addEventListener("abort", abort, { once: true });
    c.imcReleaseSignal = () => callerSignal.removeEventListener("abort", abort);
  }
  c.signal = controller.signal;
  c.imcSessionVersion = sessionVersion;
  c.imcController = controller;
  pending.add(controller);
  return c;
});
api.interceptors.response.use(
  (response) => {
    response.config.imcReleaseSignal?.();
    if (response.config.imcInvalidatesOverview) invalidateOverviewCache();
    if (response.config.imcController) pending.delete(response.config.imcController);
    return response;
  },
  (error) => {
    const config = error.config || {};
    config.imcReleaseSignal?.();
    if (config.imcInvalidatesOverview) invalidateOverviewCache();
    if (config.imcController) pending.delete(config.imcController);
    const stale = config.imcSessionVersion !== sessionVersion;
    const isAuthFlow = /\/auth\/(login|logout)/.test(String(config.url || ""));
    const recoverable = error.code === "ERR_CANCELED" || (error.response?.status === 401 && (stale || authTransitioning) && !isAuthFlow);
    if (recoverable) return new Promise(() => {});
    return Promise.reject(error);
  }
);

installReportCache(api, () => new axios.CanceledError("Report context changed"));
